import { TDeviceType } from '@cian/ui-kit';
import { ConfigurationError } from '@cian/peperrors/shared';

import { pageTypes } from 'shared/services/analytics/lib/track_event';

import { TrackEventArgs, TServiceInitArgs } from './analytics.types';
import { getPage, trackEvent } from './lib';
import { TPageType } from '../../common/types/applicationContext';

/**
 * Сервис продуктовой аналитики.
 * Является синглтоном и инициализируется в момент рендеринга страницы.
 * После инициализации можно вызывать метод trackEvent для отправки событий.
 * @example productAnalytics.trackEvent({ action: 'click', label: 'button', extra: { foo: 'bar' } });
 */
export class ProductAnalyticsService {
  private track: ReturnType<typeof trackEvent>;
  private deviceType: TDeviceType;
  private userId: number | null;
  private applicationId: number | null;

  private static instance: ProductAnalyticsService;

  protected constructor() {}

  public static getInstance = (): ProductAnalyticsService => {
    if (!this.instance) {
      this.instance = new ProductAnalyticsService();
    }

    return this.instance;
  };

  public init = ({ deviceType, pageType, userId }: TServiceInitArgs) => {
    this.deviceType = deviceType;
    this.userId = userId;
    this.track = trackEvent(deviceType, pageType);
  };

  public setApplicationId = (applicationId: number | null) => {
    this.applicationId = applicationId;
  };

  public getPageViewObject(userId: number | null, pageType: TPageType) {
    return {
      user: {
        userId,
      },
      page: getPage({ deviceType: this.deviceType, pageType: pageTypes[pageType] }),
    };
  }

  public trackEvent = ({ action, label, extra }: TrackEventArgs) => {
    if (!this.track) {
      throw new ConfigurationError({
        message: 'ProductAnalyticsService не был инициализирован',
        domain: 'services/analytics.service.ts',
      });
    }

    this.track({
      action,
      label,
      user: { userId: this.userId },
      extra: { applicationId: this.applicationId, ...extra },
    });
  };
}

export const productAnalyticsService = ProductAnalyticsService.getInstance();
